var _defs, _path, _path2, _rect, _path3, _rect2, _rect3, _rect4, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _rect5, _circle, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustratieKnowStudy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191.93705 171.72352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8e260;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n        opacity: 0.1;\n      }\n\n      .cls-3 {\n        fill: #919191;\n      }\n\n      .cls-4 {\n        fill: #e3e3e3;\n      }\n\n      .cls-5 {\n        fill: #454545;\n      }\n\n      .cls-6 {\n        fill: #757575;\n      }\n\n      .cls-7 {\n        fill: #191847;\n      }\n\n      .cls-8 {\n        fill: #e0c1a4;\n      }\n\n      .cls-9 {\n        fill: #6bad7c;\n      }\n\n      .cls-10 {\n        fill: #987f51;\n      }\n\n      .cls-11 {\n        fill: #dde3e9;\n      }\n\n      .cls-12 {\n        fill: #79c48e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    className: "cls-1",
    d: "M191.937,67.49231a45.05589,45.05589,0,0,0-45.05652-45.05542q-.89355,0-1.7865.03541a45.05571,45.05571,0,0,0-33.37194,73.19384,44.25311,44.25311,0,0,1,9.981,27.646v1.6001h50.208v-.88306a45.84107,45.84107,0,0,1,10.23706-28.5061A44.85049,44.85049,0,0,0,191.937,67.49231Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    className: "cls-2",
    d: "M191.93408,67.49134a44.83774,44.83774,0,0,1-9.787,28.03808,45.8334,45.8334,0,0,0-10.23095,28.5v.88306h-8.21a45.95776,45.95776,0,0,1,10.223-27.69995,45.04522,45.04522,0,0,0-35.27173-73.08838q-.88989,0-1.7793.0354c-1.047.03711-2.084.1189-3.113.23706a44.53738,44.53738,0,0,1,11.334-1.9209A45.051,45.051,0,0,1,191.8988,65.7074Q191.934,66.59912,191.93408,67.49134Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1559",
    "data-name": "Rectangle 1559",
    className: "cls-3",
    x: 125.386,
    y: 123.61436,
    width: 44.497,
    height: 38.483
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    className: "cls-3",
    d: "M136.509,160.59852a11.12493,11.12493,0,0,0,11.125,11.125h0a11.12412,11.12412,0,0,0,11.124-11.124v-.001Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1560",
    "data-name": "Rectangle 1560",
    className: "cls-4",
    x: 119.858,
    y: 123.61436,
    width: 54.12,
    height: 8.983,
    rx: 3.052
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1561",
    "data-name": "Rectangle 1561",
    className: "cls-4",
    x: 120.539,
    y: 138.36436,
    width: 54.12,
    height: 8.983,
    rx: 3.052
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1562",
    "data-name": "Rectangle 1562",
    className: "cls-4",
    x: 120.539,
    y: 153.11435,
    width: 54.12,
    height: 8.983,
    rx: 3.052
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Leg",
    className: "cls-5",
    d: "M42.98389,74.31946l11.45495,90.06592H46.57678l-10.78-38.21606-14.775-51.8501Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Leg-2",
    className: "cls-6",
    d: "M43.03088,74.31946c-7.233,25.5669-8.673,43.727-8.673,43.727s-1.891,17.36792-10.043,46.33912H16.16882c.98-5.415,1.76294-10.51807,2.387-15.219a171.11161,171.11161,0,0,0,.191-44.123,222.38948,222.38948,0,0,1-1.677-30.72412Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe",
    className: "cls-7",
    d: "M19.51685,171.72053v-.81592l5.3.814h15.485v-1.6289s-9.806-2.64893-15.894-6.929h-8.558l-.408,8.55908Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe-2",
    className: "cls-7",
    d: "M49.55,171.72053v-.81592l5.3.814H70.33793v-1.6289s-9.807-2.64893-15.895-6.929h-8.557l-.408,8.55908Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    className: "cls-8",
    d: "M66.212,41.7394,81.7559,34.91347a36.84563,36.84563,0,0,1,7.889-6.18506c.757-.24194,2.054-.314.67,1.7s-2.746,4.19995-2.193,4.91211,2.151-.074,2.78406,1.07593q.63006,1.15283-8.09094,2.75391l-11.64,8.925Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Back",
    "data-name": "Coat Back",
    className: "cls-9",
    d: "M29.56593,23.51946l3.709-.636c8.077,7.835,16.413,16.02295,21.80005,18.512,5.089,2.356,14.31-3.029,22.887-6.10693l2.629,5.86694c-7.793,8.43311-24.394,15.55591-31.12195,11.491C38.70692,46.14958,29.17689,36.67546,29.56593,23.51946Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Head-2",
    className: "cls-8",
    d: "M41.044,32.36358,39.289,19.95147c2.8,1.68506,5.541,2.5,6.831,2.166,3.233-.832,3.528-12.65795,1.028-17.32006s-15.36-6.6941-16.009,2.543a11.6999,11.6999,0,0,0,3.111,8.39991l-3.567,16.624Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "cls-10",
    d: "M39.806,8.36048a8.41817,8.41817,0,0,1,2.876-2.94312c4.55505.072,5.087-.74389,5.087-3.5a16.03029,16.03029,0,0,0-6.236-1.66089,7.50437,7.50437,0,0,0-4.933.364,6.393,6.393,0,0,0-4.639,4.25806c-2.825,4.87792-.681,9.95605,2.212,11.69091.76794-.91211,1.43994-1.8,2.03894-2.64209a2.59035,2.59035,0,0,1,1.80981-4.44214H38.022a2.53092,2.53092,0,0,1,.31006.01905C38.677,9.61658,39.333,9.08558,39.806,8.36048Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "cls-11",
    d: "M32.485,22.43846l9.527,1.49292c0,18.06494,1.345,37.917,3.86206,50.60694l.609,3.10009a1.73369,1.73369,0,0,1-1.81995,2.064l-24.183-1.65308C22.42893,55.2434,24.605,35.11156,32.485,22.43846Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Front",
    "data-name": "Coat Front",
    className: "cls-12",
    d: "M0,80.47338l18.52,2.531c21.81006-17.3999,17.125-60.56689,17.125-60.56689H31.87C14.72791,28.74657,12.265,57.94237,0,80.47338Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1563",
    "data-name": "Rectangle 1563",
    className: "cls-5",
    x: 32.58144,
    y: 58.99432,
    width: 31.35239,
    height: 20.46699,
    rx: 1.31981,
    transform: "translate(-34.77484 54.16471) rotate(-44.83792)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    className: "cls-6",
    cx: 48.26099,
    cy: 69.23255,
    r: 5.625
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    className: "cls-8",
    d: "M56.59391,71.01135a4.34183,4.34183,0,0,0-4.9.335l-4.415-7.561-6.1,5.68189,7.506,5.21508s-.81995,3.51807,1.57605,5.083,4.265,1.33106,4.469-.17309.848-.84912,1.415-1.88208S57.955,76.319,57.61393,75.473s1.322-1.009,1.19995-2.02S56.59391,71.01135,56.59391,71.01135Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Back-2",
    "data-name": "Coat Back-2",
    className: "cls-12",
    d: "M21.736,37.97536c2.215,8.427,10.349,24.781,23.726,36.30909l5.339-6.28711c-11.251-15.167-8.968-22.895-16.113-43.344C34.689,24.65334,18.01591,29.14138,21.736,37.97536Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratieKnowStudy);
export default __webpack_public_path__ + "static/media/illustratie_know_study.493a86497906b9fbfbd52f85767b0db9.svg";
export { ForwardRef as ReactComponent };